/**
 * Created by weid on 2017/6/21.
 */
import typesGenerator from 'typesGenerator';

const types = typesGenerator(
    'qmyxRoot',
    `

SET_USER_INFO
SET_CITY
SET_LOC_CITY
SET_CURRENT_CITY
SET_GLOBAL_CONFIG
SET_LOGINED
SET_MOBILE_DISTRICT

`
);

export default types;



// WEBPACK FOOTER //
// ./src/rootRedux/constants/qmyxTypes.js